import React from "react";
import { Box, Chip } from "@mui/material";

interface TagGridProps {
  /** 表示するタグの配列 */
  tags: string[];
}

/**
 * タグをグリッド形式で表示するコンポーネント
 * タグの長さに応じて自動的に折り返します
 *
 * @param tags - 表示するタグの配列
 */
export const TagGrid: React.FC<TagGridProps> = ({ tags }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.5,
        alignItems: "start",
        py: 0.5,
      }}
    >
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={tag}
          size="small"
          sx={{
            height: "auto",
            fontSize: "11px",
            "& .MuiChip-label": {
              px: 1,
              whiteSpace: "normal",
              wordBreak: "break-word",
            },
          }}
        />
      ))}
    </Box>
  );
};
